module fdm {

    export interface IApplicationSettings {
        name: string;
        clientName: string;
        clientStatus: string;
        logo: string;
        smallLogo: string;
        version: string;
        systemEnv: string;
        color: {
            primary: string;
            info: string;
            success: string;
            warning: string;
            danger: string;
            light: string;
            dark: string;
            black: string;
        };
        settings: {
            themeID: number;
            navbarHeaderColor: string;
            navbarCollapseColor: string;
            asideColor: string;
            headerFixed: boolean;
            asideFixed: boolean;
            asideFolded: boolean;
            asideDock: boolean;
            container: boolean;
            footerColor: string;
        };
    }


    export interface IAppRootScopeService extends ng.IRootScopeService {
        $state: ng.ui.IStateService;
        $stateParams: ng.ui.IStateParamsService;

        userInfo: dg.modules.users.IUserInfo;
        currentClient: dg.clients.IClientInfo;
    }

    //export class AppContainerController {

    //}

    //angular.module('fdm')
    //    .controller('AppContainerController', AppContainerController);

    function fdmApp(): ng.IDirective {
        return {
            restrict: 'A',
            templateUrl: '/app/src/layout/fdm-app.html'
        };
    }

    angular.module('fdm')
        .directive('fdmApp', fdmApp);
}